/**
 * @file useUserAccountBinding.js
 * @description 邮箱绑定页逻辑（待实现）
 * @module features/user/composables/useUserAccountBinding
 */

export function useUserAccountBinding() {
  function bindNewEmail() {
      }

  return { bindNewEmail }
}
